import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useTmpAuthAtom from "shared/model/useConfrimCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostAuthSignup = (idRef, pwRef, nameRef, nicknameRef) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteTmpToken] = useTmpAuthAtom()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = (uploadPath) => {
        fetchRequest("POST", "/auth/signup", {
            "id": idRef?.current?.value.trim(),
            "password": pwRef?.current?.value.trim(),
            "name": nameRef?.current?.value,
            "nickname": nicknameRef?.current?.value,
            "profile_img": uploadPath
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                if (fetchResult?.data?.sync) setAlert("기존에 가입된 계정이 있어 동기화 되었습니다.")
                else setAlert("회원가입이 완료되었습니다.")
                deleteTmpToken()
                navigate("/")
                break
            case 400:
                if (fetchResult?.data?.error_code === "id") setAlert("아이디 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "password") setAlert("비밀번호 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "name") setAlert("이름 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "nickname") setAlert("닉네임 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 409:
                if (fetchResult?.data?.error_code === "id") setAlert("이미 존재하는 아이디 입니다.")
                else if (fetchResult?.data?.error_code === "nickname") setAlert("이미 존재하는 닉네임 입니다.")
                else if (fetchResult?.data?.error_code === "contact") setAlert("이미 존재하는 연락처 입니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePostAuthSignup